import React, { useEffect, useState } from 'react';
import { Upload, X } from 'react-feather';
import PropTypes from 'prop-types';

import CustomUploadFiles from 'modules/Course/components/CustomUploadFiles';
import fileApi from 'api/fileApi';
import styles from 'styles/Unit.module.scss';
import chatStyles from 'styles/Chat.module.scss';

import { Button, Col, Progress, Row } from 'reactstrap';
import ButtonAction from './ButtonAction';
import ButtonSubmit from './ButtonSubmit';
import { showToastError } from '../../../../../../../@core/components/toastify/ToastTypes';
import { allowTypeDocuments } from '../../../../../../Messages/components/Chat/InputChat';
import { handleToastError } from 'helpers';
import LoadingOverlay from 'react-loading-overlay';

const UploadFile = ({
  type,
  setType,
  onSubmitCompleteUnit,
  setIntervalFunc,
  maxSize,
  allowMultipleUploads,
  limit,
  isDisabled,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [file, setFiles] = useState();
  const [progressOrder, setProgressOrder] = useState(undefined);

  const handleUploadFile = async (file, index) => {
    try {
      setProgressOrder(index);
      const config = {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent?.loaded * 100) / progressEvent?.total,
          );
          const progress = document.getElementById(
            `progress-upload-file-${index}`,
          )?.firstElementChild;

          if (progress) {
            progress.style.width = `${percentCompleted}%`;
          }
        },
      };

      const formData = new FormData();
      formData.append('users-file', file.data);

      const fileUploaded = await fileApi.uploadUserFile(formData, config);
      return fileUploaded;
    } catch (error) {
      console.log(error);
      showToastError('Error while uploading a file');
    }
  };
  const handleSubmit = async () => {
    try {
      if (!file?.length) return;
      setIsLoading(true);
      const promise = [];
      for (let i = 0; i < file.length; i++) {
        const item = file[i];
        let result = await handleUploadFile(item, i);
        promise.push(result);
      }

      const dataFiles = await Promise.all(promise);
      const arrIds = dataFiles
        ?.map((item) => item?._id)
        ?.filter((item) => typeof item === 'string');
      if (arrIds?.length) {
        await onSubmitCompleteUnit({ _id: arrIds }, dataFiles);
      } else {
        showToastError('At least one file upload is required');
      }
    } catch (e) {
      handleToastError(e);
    } finally {
      setProgressOrder(undefined);
      setIsLoading(false);
    }
  };

  const handleChangeInput = (attachment) => {
    const arrFiles = [];
    attachment.map((item) => {
      if (
        item?.name?.match(
          /\.(ppt|pptx|doc|docx|xls|xlsx|pdf|gif|jpg|jpeg|png|zip|mp4|m4a|webm|ogg|ogv|avi|mpeg|mpg|mov|wmv|3gp|flv|mp3|aac|ogg|wav|mpeg|webm|wave|wma|ra|aif|aiff)$/,
        )
      ) {
        arrFiles.push(item);
      } else {
        showToastError(
          `Unsupported file format ${item?.name}. Please use supported formats.`,
        );
      }
    });
    if (!file && arrFiles?.length <= limit) {
      setFiles(arrFiles);
      return;
    }
    if (file?.length + arrFiles?.length <= limit) {
      setFiles([...file, ...arrFiles]);
      return;
    }
    showToastError(
      `Upload file number is exceeds the file number. Limit is ${limit} files`,
    );
  };

  const removeFile = (index) => {
    const arrFiles = [...file];
    arrFiles.splice(index, 1);
    setFiles(arrFiles);
  };

  useEffect(() => {
    if (type) {
      setFiles(undefined);
    }
  }, [type]);

  return (
    <LoadingOverlay
      active={isLoading}
      spinner
      styles={{
        overlay: (base) => ({
          ...base,
          background: 'rgb(187 181 181 / 50%)',
        }),
      }}
    >
      {type === 'FILE' && (
        <>
          <CustomUploadFiles
            className="course__files__drag-and-drop"
            maxSize={maxSize}
            allowMultipleUploads={allowMultipleUploads}
            maxNumberOfFiles={limit}
            onChange={handleChangeInput}
          />
          {file?.length ? (
            <div className="my-1">
              <p>Your file:</p>
              {file.map((item, index) => (
                <Row className="mx-0" key={index}>
                  <Col className="col-12 mb-05">
                    {item?.name}
                    <Button.Ripple
                      className="btn-icon rounded-circle ml-05 px-0 py-0"
                      outline
                      color="secondary"
                      onClick={() => removeFile(index)}
                      disabled={isDisabled}
                    >
                      <X size={16} />
                    </Button.Ripple>
                    {progressOrder === index ? (
                      <span
                        className={`pl-05 font-style-italic text-secondary font-small-2 `}
                      >
                        Uploading...
                      </span>
                    ) : null}
                  </Col>
                  <Col className="col-12">
                    <div className="mb-50">
                      {progressOrder === index ? (
                        <Progress
                          striped
                          id={`progress-upload-file-${index}`}
                          className={`${chatStyles['progress-upload-message']} `}
                        />
                      ) : null}
                    </div>
                  </Col>
                </Row>
              ))}
            </div>
          ) : null}
          <div className={styles.footerAssigment}>
            <ButtonSubmit
              title="Upload your reply"
              onCancel={() => setType('')}
              onClick={handleSubmit}
              disabled={isLoading || !file?.length || isDisabled}
              disabledCancel={isLoading}
            />
          </div>
        </>
      )}
      {!type && (
        <ButtonAction
          disabled={isDisabled}
          icon={<Upload />}
          text="Upload a file"
          onClick={() => {
            setType('FILE');
            setIntervalFunc();
          }}
        />
      )}
    </LoadingOverlay>
  );
};

UploadFile.propTypes = {
  type: PropTypes.string.isRequired,
  setType: PropTypes.func.isRequired,
  onSubmitCompleteUnit: PropTypes.func.isRequired,
};

export default UploadFile;
